import { TextCodes } from '@api/types/translation/TextCodes';
import {
  CalendarField,
  DropdownField,
  SearchField,
  technicalAttachmentsDropdownOptions,
  technicalTypeDropdownOptions,
  useTechnicalMessageContext,
} from '@components';
import { Clear } from '@mui/icons-material';
import { Box, Button, Grid } from '@mui/material';
import { t } from '@translations';
import dayjs from 'dayjs';
import { TechnicalMessageSorting } from './TechnicalMessageSorting';

export const TechnicalMessageListFilters = () => {
  const { clearFilters, updateFilters, filters } = useTechnicalMessageContext();

  const findFieldValues = (filterName: string) => {
    return Array.isArray(filters) ? filters?.find((f) => f.filterName === filterName)?.value : '';
  };

  return (
    <Box sx={{ my: 4 }}>
      <Grid
        container
        spacing={{
          xs: 4,
          lg: 3,
        }}
      >
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <SearchField
            label={t(TextCodes.TechnicalMessage.Block.Search)}
            name='filter'
            value={findFieldValues('Search')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updateFilters({ filterName: 'Search', value: e.target.value })
            }
            sx={{ width: '100%' }}
            placeholder={t(TextCodes.TechnicalMessage.Block.Search)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <DropdownField
            label={t(TextCodes.TechnicalMessage.Block.Type)}
            name='type'
            options={technicalTypeDropdownOptions()}
            value={findFieldValues('MessageType')}
            withRemoveButton
            getValue={(value: string | string[]) =>
              updateFilters({ filterName: 'MessageType', value: value as string })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <CalendarField
            value={findFieldValues('CreatedOn')}
            onChange={(e: string) => {
              updateFilters({
                filterName: 'CreatedOn',
                value: dayjs(e).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              });
            }}
            label={t(TextCodes.TechnicalMessage.Block.Date)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <DropdownField
            label={t(TextCodes.TechnicalMessage.Block.Attachments)}
            name='attachments'
            options={technicalAttachmentsDropdownOptions()}
            value={
              technicalAttachmentsDropdownOptions().find(
                (option) => option.value === findFieldValues('Attachments')
              )?.label || ''
            }
            withRemoveButton
            getValue={(value: string | string[]) =>
              updateFilters({ filterName: 'Attachments', value: value as string })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <TechnicalMessageSorting />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Button variant='tertiary' onClick={clearFilters} startIcon={<Clear />}>
            {t(TextCodes.TechnicalMessage.Block.ClearFilters)}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
